import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--downloads_with_description',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
      field_search_text: null,
      field_hide_title: false,
      field_text: {
        value:
          'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.',
        format: null,
      },
      field_title: { value: 'I am a Downloads Module', format: 'rich_text' },
      field_padding_top: null,
      field_padding_bottom: null,
    },
    relationships: {
      field_downloads_with_description: {
        data: [],
      },
      field_tags: {
        data: [],
      },
    },
    links: {},
    log: [],
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
